const __vite_glob_0_154 = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"17\" height=\"17\" viewBox=\"0 0 17 17\"><path fill=\"#212121\" d=\"M.079 15.822 6.23 8.398.08.974A.339.339 0 0 1 .34.417h9.453a.34.34 0 0 1 .262.122l6.346 7.642a.34.34 0 0 1 0 .435l-6.346 7.641a.34.34 0 0 1-.262.122H.341a.34.34 0 0 1-.262-.557Z\"/></svg>\n";

export { __vite_glob_0_154 as default };
